module.exports = __webpack_public_path__ + "img/HOME.5d4d9a91.svg";